import guard from "./auth-guard";
import router from "./route";

router.beforeEach(guard)

export default router